import * as React from 'react';
import { IgcColumnGroupComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcColumnGroupComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * **Ignite UI for Angular Column Group**
 * @fires hiddenChange - Emitted when the column is hidden or shown.
 * @fires expandedChange - Emitted when the column expanded or collapsed.
 * @fires widthChange - Emitted when the column width changes.
 * @fires pinnedChange - Emitted when the column is pinned/unpinned.
 * @class
 */
export const IgrColumnGroup = /* @__PURE__ */ createComponent({
  tagName: 'igc-column-group',
  displayName: 'IgrColumnGroup',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onHiddenChange: 'hiddenChange' as EventName<
      IgcColumnGroupComponentEventMap['hiddenChange']
    >,
    onExpandedChange: 'expandedChange' as EventName<
      IgcColumnGroupComponentEventMap['expandedChange']
    >,
    onWidthChange: 'widthChange' as EventName<
      IgcColumnGroupComponentEventMap['widthChange']
    >,
    onPinnedChange: 'pinnedChange' as EventName<
      IgcColumnGroupComponentEventMap['pinnedChange']
    >,
  },
  renderProps: {
    collapsibleIndicatorTemplate: 'collapsibleIndicatorTemplate',
    summaryTemplate: 'summaryTemplate',
    bodyTemplate: 'bodyTemplate',
    headerTemplate: 'headerTemplate',
    inlineEditorTemplate: 'inlineEditorTemplate',
    errorTemplate: 'errorTemplate',
    filterCellTemplate: 'filterCellTemplate',
  },
});

export type IgrColumnGroup = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrColumnGroupModule = Component;
